module.exports = __webpack_public_path__ + "static/media/health-care.40bf0fb6.jpeg";